'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {

    window.setTimeout(function () {
        var appendButton = document.getElementById('append-button');
        var lengthMenuSelect = document.querySelector('#mainContent .length-menu, .pagination__wrap .length-menu');
        if (appendButton && lengthMenuSelect && Resx.App.LoadNextRecords) {

            var changeTextAppendAll = function changeTextAppendAll() {
                try {
                    appendButton.textContent = Resx.App.LoadNextRecords.replace('{0}', lengthMenuSelect.value);

                    var itemsCountInfo = document.querySelector('.dataTables_info');
                    if (!itemsCountInfo) return;

                    var numsArray = itemsCountInfo.textContent.match(/[0-9]+/g);
                    if (!numsArray || numsArray.length < 3) return;

                    var itemsCount = document.querySelectorAll('.p-l__item, article.event.event--new').length;

                    itemsCountInfo.textContent = Resx.DataTables.sInfo.replace('_START_', numsArray[0]).replace('_END_', parseInt(numsArray[0]) + itemsCount - 1).replace('_TOTAL_', numsArray[2]);
                } catch (e) {
                    console.error('Error in changeTextAppendAll', e);
                }
            };
            changeTextAppendAll();

            (0, _jquery2.default)(lengthMenuSelect).on('select2:select', function (e) {
                changeTextAppendAll();
            });
        }
    }, 300);

    (0, _jquery2.default)('#append-button', this).off('click').on('click', function (e) {
        e.preventDefault();

        var $this = (0, _jquery2.default)(this);
        var currentPage = parseInt($this.attr('data-current-page'));
        var baseUrl = location.protocol + '//' + location.host + location.pathname;
        var dataContainer = (0, _jquery2.default)('[data-pagination]', document).attr("data-pagination");

        var paging = JSON.parse((0, _jquery2.default)(dataContainer).find('[data-paging="true"]').val());
        if (!paging) paging = { totalCount: 0, pageSize: 20, page: 1 };

        var maxPages = paging.totalCount === 0 ? 0 : Math.floor(paging.totalCount / paging.pageSize) + (paging.totalCount % paging.pageSize === 0 ? 0 : 1);

        if (baseUrl) {
            var sortInUse = getParameterByName('sort');
            var tagInUse = getParameterByName('tag');

            var url = baseUrl.match(/\/$/) ? baseUrl.substring(0, baseUrl.length - 1) : baseUrl;
            var nextPage = currentPage + 1;

            if (nextPage > maxPages) return;

            // add 'isLoadMore' flag to indicate that the result should contain only the list of items, and nothing else
            var queryString = window.location.search.replace("?", "&");
            var finalUrl = url + '/?isLoadMore=true&page=' + nextPage + '&pageSize=' + paging.pageSize + queryString;

            if (sortInUse) {
                finalUrl = finalUrl + "&sort=" + sortInUse;
            }

            if (tagInUse) {
                finalUrl = finalUrl + "&tag=" + tagInUse;
            }

            $this.attr('data-ajax-url', finalUrl);
            $this.attr('data-current-page', nextPage);

            (0, _ajax.htmlAjax)({
                target: $this,
                url: $this.attr('data-ajax-url'),
                method: 'POST',
                data: []
            });

            activatePageButton(nextPage);

            if (nextPage === maxPages) {
                $this.hide();
            }
        }
    });

    function activatePageButton(pageNumber) {
        var pages = (0, _jquery2.default)('.pagination__wrap li a');

        var activePage = pages.parent().closest('.active');
        var nextPage = pages.closest('[href=?page=' + pageNumber + ']')[0];

        if (nextPage) {
            activePage.removeClass('active');
            (0, _jquery2.default)(nextPage).parent().addClass('active');
        }
    }
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _ajax = require('linksoft/utils/ajax');

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('DataTables', 'App');

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/appendResult.js
// module id = 1055
// module chunks = 0